/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Active_Jumpy_Pony_ExpressInputs */

const fr_active_jumpy_pony_express = /** @type {(inputs: Active_Jumpy_Pony_ExpressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type d'évenement`)
};

/**

* @param {Active_Jumpy_Pony_ExpressInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const active_jumpy_pony_express = /** @type {((inputs?: Active_Jumpy_Pony_ExpressInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Active_Jumpy_Pony_ExpressInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_active_jumpy_pony_express(inputs)
});